import FlatButton from './FlatButton'

const exportObj = {
    FlatButton
}

export default exportObj